<template>
  <div class="material">
    <div class="function-bar">
      <div v-if="0"
           class="function-bar-frequency">
        <img src="../../icon/paibi.png"
             alt="">
        <p>10</p>
      </div>
      <div class="function-bar-create">
        <p @click="randomInspiration">{{ $t('CustomSpus.AI.randomInspiration') }}</p>
        <a-button v-if="!loading"
                  class="function-bar-create-button"
                  type="primary"
                  @click="createMJ">{{ $t('CustomSpus.AI.create') }}</a-button>
        <a-button v-else
                  class="loading-button"
                  type="primary"
                  disabled
                  @click="createMJ">{{ $t('CustomSpus.AI.create') }}</a-button>
      </div>
    </div>
    <a-textarea v-model:value="inspirationKeywords"
                class="key-words-input"
                :placeholder="$t('CustomSpus.AI.keywordsPlaceholder')"
                :auto-size="{ minRows: 2, maxRows: 2 }" />
    <a-tabs v-model:activeKey="activeKey"
            tab-bar-gutter="0">
      <template #renderTabBar>
        <div class="tab-pane">
          <div :class="['tab', activeKey === '1' ? 'selected' : 'select']"
               @click="activeKey = '1'">
            {{ $t('CustomSpus.AI.tab1') }}
          </div>
          <div :class="['tab', activeKey === '2' ? 'selected' : 'select']"
               @click="activeKey = '2'">
            {{ $t('CustomSpus.AI.tab2') }}
          </div>
        </div>
      </template>
      <a-tab-pane key="1"
                  :tab="$t('CustomSpus.AI.tab1')">
        <ul class="material-list">
          <li v-for="(item, index) in preset_image"
              :key="index"
              class="material-item three-columns"
              @click="addImage(item.image)">
            <a-popover trigger="hover"
                       :mouse-enter-delay='1'
                       placement="left"
                       :get-popup-container="(triggerNode: any) => { return triggerNode.parentNode }">
              <template #content>
                <div class="image-content">
                  <img class="image-content-img"
                       :src="item.image" />
                  <div class="image-content-desc">{{ item.desc }}</div>
                  <div class="image-content-specification">
                    <p>1024 x 1024</p>
                    <p>JPG</p>
                  </div>
                </div>
              </template>
              <img class="material-img"
                   :src="item.image" />
            </a-popover>
          </li>
        </ul>
      </a-tab-pane>
      <a-tab-pane key="2"
                  :tab="$t('CustomSpus.AI.tab2')"
                  force-render>
        <div v-if="!loading"
             class="img-history">
          <div v-if="(MJImgs?.length || MJImgsHistroy?.length) && props.isLogin">
            <ul class="material-list">
              <li v-for="(item, index) in MJImgs"
                  v-show="index < 4"
                  :key="index"
                  class="material-item two-columns"
                  @click="addImage(`${item.imageUrl!}width=800&height=800`)">
                <a-popover trigger="hover"
                           :mouse-enter-delay='1'
                           placement="left"
                           :get-popup-container="(triggerNode: any) => { return triggerNode.parentNode }">
                  <template #content>
                    <div class="image-content">
                      <img class="image-content-img"
                           :src="`${item.imageUrl}?x-oss-process=image/resize,w_90/quality,q_90`" />
                      <div class="image-content-desc">{{ item.prompt }}</div>
                      <div class="image-content-specification">
                        <p>{{ $t('CustomSpus.AI.imageSpecification') }}</p>
                        <p>{{ $t('CustomSpus.AI.imageFormat') }}</p>
                      </div>
                    </div>
                  </template>
                  <img class="material-img"
                       :src="`${item.imageUrl}?x-oss-process=image/resize,w_200/quality,q_90`" />
                </a-popover>
              </li>
            </ul>
            <div>
              <div class="record-title">
                <h4>{{ $t('CustomSpus.AI.creationRecord') }}</h4>
                <p>{{ $t('CustomSpus.AI.recordRetention') }}</p>
              </div>
              <ul>
                <li v-for="(item, index) in MJImgsHistroy"
                    :key="index">
                  <ul class="material-list">
                    <li v-for="(ite, i) in item.subData"
                        :key="i"
                        class="material-item two-columns"
                        @click="addImage(ite.imageUrl!)">
                      <a-popover trigger="hover"
                                 :mouse-enter-delay='1'
                                 placement="left"
                                 :get-popup-container="(triggerNode: any) => { return triggerNode.parentNode }">
                        <template #content>
                          <div class="image-content">
                            <img class="image-content-img"
                                 :src="ite.imageUrl + '?x-oss-process=image/resize,w_90/quality,q_90'" />
                            <div class="image-content-desc">{{ ite.prompt }}</div>
                            <div class="image-content-specification">
                              <p>{{ $t('CustomSpus.AI.imageSpecification') }}</p>
                              <p>{{ $t('CustomSpus.AI.imageFormat') }}</p>
                            </div>
                          </div>
                        </template>
                        <img class="material-img"
                             :src="ite.imageUrl + '?x-oss-process=image/resize,w_200/quality,q_90'" />
                      </a-popover>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div v-else
               class="no-img">
            <img src="../../icon/no-MJ-img.png">
            <p>{{ $t('CustomSpus.AI.noImgMessage') }}</p>
          </div>
        </div>
        <div v-else
             class="loading">
          <img src="../../icon/loading.png">
          <div class="loading-progress">
            <div class="loading-progress-bar"
                 :style="{ width: `${schedule}%` }" />
          </div>
          <p>{{ $t('CustomSpus.AI.loadingMessage1') }}</p>
          <p>{{ $t('CustomSpus.AI.loadingMessage2') }}</p>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch, computed } from 'vue'
import { message } from 'ant-design-vue'
import type { MJImg } from '../../types'
import { createMJImg, fetchMainImg, fetchFourMJImg, fetchFourMJImgHistroy } from "../../api"
import image_bonfire from '../../../home/assets/ai_imgs/image_bonfire.jpg'
import image_lighthouse from '../../../home/assets/ai_imgs/image_lighthouse.jpg'
import image_train from '../../../home/assets/ai_imgs/image_train.jpg'
import image_street from '../../../home/assets/ai_imgs/image_street.jpg'
import image_music_festival from '../../../home/assets/ai_imgs/image_music_festival.jpg'
import image_tangerine from '../../../home/assets/ai_imgs/image_tangerine.jpg'
import image_wooden from '../../../home/assets/ai_imgs/image_wooden.jpg'
import image_grass from '../../../home/assets/ai_imgs/image_grass.jpg'
import image_table from '../../../home/assets/ai_imgs/image_table.jpg'
import image_landscape from '../../../home/assets/ai_imgs/image_landscape.jpg'
import image_cowboy from '../../../home/assets/ai_imgs/image_cowboy.jpg'
import image_girl from '../../../home/assets/ai_imgs/image_girl.jpg'
import image_cat from '../../../home/assets/ai_imgs/image_cat.jpg'
import image_sea_mew from '../../../home/assets/ai_imgs/image_sea_mew.jpg'
import image_food_stand from '../../../home/assets/ai_imgs/image_food_stand.jpg'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps<{
  isLogin: any
  paramsImg: boolean
}>()
const preset_image = computed(() => [
  {
    image: image_bonfire,
    desc: t('CustomSpus.AI.bonfire')
  },
  {
    image: image_lighthouse,
    desc: t('CustomSpus.AI.lighthouse')
  },
  {
    image: image_train,
    desc: t('CustomSpus.AI.train')
  },
  {
    image: image_street,
    desc: t('CustomSpus.AI.street')
  },
  {
    image: image_music_festival,
    desc: t('CustomSpus.AI.musicFestival')
  },
  {
    image: image_tangerine,
    desc: t('CustomSpus.AI.tangerine')
  },
  {
    image: image_wooden,
    desc: t('CustomSpus.AI.wooden')
  },
  {
    image: image_grass,
    desc: t('CustomSpus.AI.grass')
  },
  {
    image: image_table,
    desc: t('CustomSpus.AI.table')
  },
  {
    image: image_landscape,
    desc: t('CustomSpus.AI.landscape')
  },
  {
    image: image_cowboy,
    desc: t('CustomSpus.AI.cowboy')
  },
  {
    image: image_girl,
    desc: t('CustomSpus.AI.girl')
  },
  {
    image: image_cat,
    desc: t('CustomSpus.AI.cat')
  },
  {
    image: image_sea_mew,
    desc: t('CustomSpus.AI.seaMew')
  },
  {
    image: image_food_stand,
    desc: t('CustomSpus.AI.foodStand')
  }
])
const timer = ref<any>()
const MJImgsHistroy = ref<Array<MJImg>>()
const loading = ref<boolean>(false)
const inspirationKeywords = ref<string>('')
const activeKey = ref<string>('1')
const schedule = ref<number>(0)
const MJImgs = ref<Array<MJImg>>()
const wordsInspiration = computed(() => [
  t('CustomSpus.AI.wordsInspiration.dream'),
  t('CustomSpus.AI.wordsInspiration.dog'),
  t('CustomSpus.AI.wordsInspiration.cats'),
  t('CustomSpus.AI.wordsInspiration.mountain'),
  t('CustomSpus.AI.wordsInspiration.water'),
  t('CustomSpus.AI.wordsInspiration.wind'),
  t('CustomSpus.AI.wordsInspiration.rain'),
  t('CustomSpus.AI.wordsInspiration.flower'),
  t('CustomSpus.AI.wordsInspiration.tree'),
  t('CustomSpus.AI.wordsInspiration.bird'),
  t('CustomSpus.AI.wordsInspiration.sun'),
  t('CustomSpus.AI.wordsInspiration.moon'),
  t('CustomSpus.AI.wordsInspiration.star'),
  t('CustomSpus.AI.wordsInspiration.stone'),
  t('CustomSpus.AI.wordsInspiration.sea'),
  t('CustomSpus.AI.wordsInspiration.lake'),
  t('CustomSpus.AI.wordsInspiration.snow'),
  t('CustomSpus.AI.wordsInspiration.glass'),
  t('CustomSpus.AI.wordsInspiration.spring'),
  t('CustomSpus.AI.wordsInspiration.bridge'),
  t('CustomSpus.AI.wordsInspiration.cloud'),
  t('CustomSpus.AI.wordsInspiration.fire'),
  t('CustomSpus.AI.wordsInspiration.eat'),
  t('CustomSpus.AI.wordsInspiration.fruit'),
  t('CustomSpus.AI.wordsInspiration.tea'),
  t('CustomSpus.AI.wordsInspiration.dreamscape'),
  t('CustomSpus.AI.wordsInspiration.starrySky'),
  t('CustomSpus.AI.wordsInspiration.fantasy'),
  t('CustomSpus.AI.wordsInspiration.happiness'),
  t('CustomSpus.AI.wordsInspiration.sunshine'),
  t('CustomSpus.AI.wordsInspiration.moonLight'),
  t('CustomSpus.AI.wordsInspiration.greenTrees'),
  t('CustomSpus.AI.wordsInspiration.blueSky'),
  t('CustomSpus.AI.wordsInspiration.whiteClouds'),
  t('CustomSpus.AI.wordsInspiration.seawaves'),
  t('CustomSpus.AI.wordsInspiration.flowingWater'),
  t('CustomSpus.AI.wordsInspiration.mountainsRivers'),
  t('CustomSpus.AI.wordsInspiration.stones'),
  t('CustomSpus.AI.wordsInspiration.windRain'),
  t('CustomSpus.AI.wordsInspiration.ocean'),
  t('CustomSpus.AI.wordsInspiration.asbyss'),
  t('CustomSpus.AI.wordsInspiration.iceSnow'),
  t('CustomSpus.AI.wordsInspiration.springDay'),
  t('CustomSpus.AI.wordsInspiration.autumnLeaves'),
  t('CustomSpus.AI.wordsInspiration.flowers'),
  t('CustomSpus.AI.wordsInspiration.waterfall'),
  t('CustomSpus.AI.wordsInspiration.stars'),
  t('CustomSpus.AI.wordsInspiration.constellations'),
  t('CustomSpus.AI.wordsInspiration.rainbow'),
  t('CustomSpus.AI.wordsInspiration.snowflake'),
  t('CustomSpus.AI.wordsInspiration.senseMystery'),
  t('CustomSpus.AI.wordsInspiration.warmHeart'),
  t('CustomSpus.AI.wordsInspiration.momentsHappiness'),
  t('CustomSpus.AI.wordsInspiration.smilingFace'),
  t('CustomSpus.AI.wordsInspiration.dreamlikeRealm'),
  t('CustomSpus.AI.wordsInspiration.underGreenTrees'),
  t('CustomSpus.AI.wordsInspiration.brillianceStarlight'),
  t('CustomSpus.AI.wordsInspiration.luckyStar'),
  t('CustomSpus.AI.wordsInspiration.inForest'),
  t('CustomSpus.AI.wordsInspiration.quietNight'),
  t('CustomSpus.AI.wordsInspiration.soundWater'),
  t('CustomSpus.AI.wordsInspiration.deepSea'),
  t('CustomSpus.AI.wordsInspiration.brightMorning'),
  t('CustomSpus.AI.wordsInspiration.inFlight'),
  t('CustomSpus.AI.wordsInspiration.laughingFace'),
  t('CustomSpus.AI.wordsInspiration.feelingSadness'),
  t('CustomSpus.AI.wordsInspiration.momentsDeepAffection'),
  t('CustomSpus.AI.wordsInspiration.timesContemplation'),
  t('CustomSpus.AI.wordsInspiration.senseWorry'),
  t('CustomSpus.AI.wordsInspiration.poeticBeauty'),
  t('CustomSpus.AI.wordsInspiration.senseJoy'),
  t('CustomSpus.AI.wordsInspiration.thanksgiving'),
  t('CustomSpus.AI.wordsInspiration.nationalDay'),
  t('CustomSpus.AI.wordsInspiration.senseWilderness'),
  t('CustomSpus.AI.wordsInspiration.whenFlowersBloom'),
  t('CustomSpus.AI.wordsInspiration.timesLonging'),
  t('CustomSpus.AI.wordsInspiration.ancientPrayer'),
  t('CustomSpus.AI.wordsInspiration.twinklingStars'),
  t('CustomSpus.AI.wordsInspiration.warmEver'),
  t('CustomSpus.AI.wordsInspiration.overflowingHappiness'),
  t('CustomSpus.AI.wordsInspiration.blossomingFlowers'),
  t('CustomSpus.AI.wordsInspiration.lightHope'),
  t('CustomSpus.AI.wordsInspiration.beautifulPainting'),
  t('CustomSpus.AI.wordsInspiration.timeFlies'),
  t('CustomSpus.AI.wordsInspiration.tranquilityTime'),
  t('CustomSpus.AI.wordsInspiration.endlessDesert'),
  t('CustomSpus.AI.wordsInspiration.windowSoul'),
  t('CustomSpus.AI.wordsInspiration.magicalMoments'),
  t('CustomSpus.AI.wordsInspiration.flowersSea'),
  t('CustomSpus.AI.wordsInspiration.brilliantStarlight'),
  t('CustomSpus.AI.wordsInspiration.dreamsComeTrue'),
  t('CustomSpus.AI.wordsInspiration.autumnMapleLeaves'),
  t('CustomSpus.AI.wordsInspiration.masteryArt'),
  t('CustomSpus.AI.wordsInspiration.splendidColorful'),
  t('CustomSpus.AI.wordsInspiration.burstInspiration'),
  t('CustomSpus.AI.wordsInspiration.brightSunshine'),
  t('CustomSpus.AI.wordsInspiration.questTreasure'),
  t('CustomSpus.AI.wordsInspiration.warmthFamily'),
  t('CustomSpus.AI.wordsInspiration.mythologicalHeritage'),
  t('CustomSpus.AI.wordsInspiration.risingRainbow'),
  t('CustomSpus.AI.wordsInspiration.magicMiracle')
])


onMounted(async () => {
  await fetchFourMJImgHistroy().then(async (result: any) => {
    const completeness = result.find((r: any) => r.progress != '100%') || result.find((r: any) => r.subData.find((rr: any) => rr.progress != '100%'))
    if (completeness) {
      emit('imgNoFinished')
      await pollingProgress(completeness.groupId)
    } else if (result[0]) {
      MJImgs.value = result[0].subData
    }
    MJImgsHistroy.value = result.slice(1, result.length)
  })
})

watch(() => props.paramsImg, () => {
  activeKey.value = '2'
})

const emit = defineEmits(['changes', 'toLogin', 'imgNoFinished'])

const addImage = (imageUrl: string) => {
  emit('changes', imageUrl)
}

const randomInspiration = () => {
  inspirationKeywords.value = ''
  const quantity = Math.floor(Math.random() * 5) + 1
  const number = [] as number[]
  for (let index = 0; index < quantity; index++) {
    let random = Math.floor(Math.random() * 100)
    while (!number.indexOf(random)) {
      random = Math.floor(Math.random() * 100)
    }
    number.push(random)
    inspirationKeywords.value += wordsInspiration.value[Math.floor(Math.random() * 100)]
    if (index != quantity - 1)
      inspirationKeywords.value += ','
  }
}

const sleep = (ms: number) => {
  return new Promise(resolve => {
    timer.value = setTimeout(resolve, ms)
  })
}

const pollingProgress = async (groupId: string) => {
  activeKey.value = '2'
  loading.value = true
  try {
    while (true) {
      const mainImg: any = await fetchMainImg(groupId)
      schedule.value = Number(mainImg.progress) / 2
      if (mainImg.message === 'Success') {
        while (true) {
          const fourMJImg: any = await fetchFourMJImg(mainImg.data.id)
          schedule.value = (100 + Number(fourMJImg.progress)) / 2
          if (fourMJImg.message === 'Success') {
            schedule.value = 100
            if (MJImgsHistroy.value)
              MJImgsHistroy.value.unshift({ subData: MJImgs.value })
            MJImgs.value = fourMJImg.data
            loading.value = false
            schedule.value = 0
            break
          }
          await sleep(2000)
        }
        break
      }
      await sleep(2000)
    }
  } catch (error) {
    console.log(error)
    loading.value = false
    message.error(t('CustomSpus.AI.creationFailed'))
  }
}

const createMJ = async () => {
  if (!props.isLogin) {
    emit('toLogin')
    return
  }

  const prompt = {
    prompt: inspirationKeywords.value
  }
  await createMJImg(prompt).then((result: any) => {
    pollingProgress(result.groupId)
  })
}
</script>
<style scoped lang="less">
* {
  margin: 0;
}

.material {
  width: 300px;
  flex: 1;
  background-color: white;
  padding: 20px;
  display: flex;
  flex-flow: column;
  overflow: hidden;

  .image-content {
    width: 255px;
    flex: 1;
    padding-bottom: 10px;

    .image-content-img {
      width: 255px;
      height: 256px;
      background: #f6f6f6;
    }

    .image-content-desc {
      margin: 10px 20px;
    }

    .image-content-specification {
      display: flex;
      justify-content: space-between;
      margin: 0 20px;

      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
    }
  }

  .loading {
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    margin-top: 100px;

    .loading-progress {
      margin: 10px 0;
      width: 80%;
      height: 10px;
      background: #F6F6F6;
      border: 1px solid #111111;
      border-radius: 5px;

      .loading-progress-bar {
        width: 0;
        height: 100%;
        background: black;
        transition: width 2s linear 0s;
      }
    }

    img {
      width: 30px;
      height: 30px;
      animation: rotate 10s linear infinite;
    }

    @keyframes rotate {
      0% {
        transform: rotate(0);
      }

      100% {
        transform: rotate(360deg);
      }
    }

    p {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }
  }

  .record-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h4 {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 600;
      color: #111111;
    }

    p {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }
  }

  .tab-pane {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 10px;

    .tab {
      margin-right: 20px;
    }

    .select {
      font-size: 18px;
      font-family: 'Microsoft YaHei';
      font-weight: 600;
      color: #999999;
      border-bottom: 4px solid rgba(0, 0, 0, 0);
    }

    .selected {
      font-size: 18px;
      font-family: 'Microsoft YaHei';
      font-weight: 600;
      color: #111111;
      border-bottom: 4px solid;
    }
  }

  .function-bar {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .function-bar-frequency {
      flex: 1;
      display: flex;
      align-items: center;

      p {
        margin-left: 10px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #111111;
      }

      img {
        width: 23px;
        height: 23px;
        background: #4791FF;
        border-radius: 50%;
      }
    }

    .function-bar-create {
      flex: 2;
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        margin-left: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        cursor: pointer;
      }

      .function-bar-create-button {
        width: 68px;
        height: 40px;
      }

      .loading-button {
        width: 68px;
        height: 40px;
        opacity: 0.4;

        &::after {
          content: "";
          animation: dots 2s infinite steps(3, start);
        }

        @keyframes dots {
          25% {
            content: " .";
          }

          50% {
            content: " ..";
          }

          75% {
            content: " ...";
          }
        }
      }
    }
  }

  .key-words-input {
    margin: 20px 0;
    flex: 1;
  }

  :deep(.ant-popover-inner-content) {
    padding: 0 !important;
  }

  .material-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: flex-start;
    flex: 1;

    .three-columns {
      width: 80px;
      height: 80px;
    }

    .two-columns {
      width: 110px;
      height: 110px;
    }

    .material-item {
      background-color: #F6F6F6;
      border-radius: 8px;
      cursor: pointer;
      margin-bottom: 10px;

      .material-img {
        width: 100%;
        height: 100%;
      }
    }

    .material-item:nth-child(3n) {
      margin-right: 0px !important;
    }
  }

  .img-history {
    flex: 1;
    overflow: auto;
    scrollbar-width: thin;
    /* Firefox */
    scrollbar-color: transparent transparent;
    /* Firefox */

    .no-img {
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      margin-top: 100px;

      img {
        margin-right: 40px;
        width: 70%;
      }

      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #CCCCCC;
      }
    }
  }

  .img-history::-webkit-scrollbar {
    width: 0.2em;
  }
}
</style>
